import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import usePageStore from '../Page/pageStore';
import MenuList from '../Menu/MenuList';
import useDataStore from '../Data/dataStore';
import FooterLink from './FooterLink';
import { LogoGraphics } from '../Header/LogoGraphics';
import { LogoTextGraphics } from '../Header/LogoTextGraphics';
import { API } from '../globalUtils';
import GradientWrapper from '../GradientBox/GradientWrapper';
const observerOptions = {
    root: null,
    rootMargin: '-100px',
};
const Footer = ({ idx, flexibleHeight, animated }) => {
    const { activeSection, shownSection, activePage, shownPage, isLastSection } = usePageStore();
    const isLastSectionRef = useRef(isLastSection);
    isLastSectionRef.current = isLastSection;
    const setup = useDataStore((state) => state.data[API.setup]);
    // TODO: check all api requests here
    const isContentReady = useDataStore((state) => !!state.data[shownPage]);
    const [isReadyToOpen, setIsReadyToOpen] = useState(false);
    const [onScreen, setOnScreen] = useState(false);
    const mounted = useRef(false);
    const sectionRef = useRef(null);
    useEffect(() => {
        mounted.current = true;
        addListeners();
        setTimeout(() => {
            if (mounted.current) {
                setIsReadyToOpen(true);
            }
        }, 300);
        return () => {
            mounted.current = false;
            removeListeners();
        };
    }, []);
    const show = !isReadyToOpen
        ? false
        : flexibleHeight
            ? !!onScreen && activePage === shownPage
            : animated
                ? shownSection === idx &&
                    activeSection === idx &&
                    activePage === shownPage &&
                    isContentReady
                : activePage === shownPage && isContentReady && isReadyToOpen;
    useEffect(() => {
        if (!animated)
            return;
        usePageStore.getState().setLastSection(show);
    }, [show]);
    const getMenu = (menuSetup) => menuSetup.map((item) => {
        const { blank, name, slug } = item;
        return _jsx(FooterLink, { name: name, link: slug, blank: blank }, name);
    });
    const addListeners = () => {
        if (sectionRef.current) {
            observer.current.observe(sectionRef.current);
        }
    };
    const removeListeners = () => {
        observer.current.disconnect();
    };
    const handleIntersect = (elements) => {
        checkIntersect(elements);
    };
    const checkIntersect = (elements) => {
        if (animated)
            return;
        const intersection = elements.reduce((acc, element) => element.target === sectionRef.current && element.isIntersecting
            ? element
            : acc, null);
        console.log('||||||', intersection);
        if (intersection) {
            if (!isLastSectionRef.current) {
                usePageStore.getState().setLastSection(true);
            }
        }
        else {
            if (isLastSectionRef.current) {
                usePageStore.getState().setLastSection(false);
            }
        }
        setOnScreen(!!intersection);
    };
    const observer = useRef(new IntersectionObserver(handleIntersect, observerOptions));
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: `footer-container${flexibleHeight ? ' adjusted' : ''}${animated ? ' animated' : ''}${show ? ' show' : ''}`, ref: sectionRef, children: _jsx("div", { className: `footer-panel`, children: _jsx("div", { className: "footer-slider", children: _jsxs("div", { className: "footer-wrapper", children: [animated && _jsx(GradientWrapper, { active: false }), _jsxs("div", { className: "footer-logo", children: [_jsx(LogoGraphics, {}), _jsx(LogoTextGraphics, {})] }), _jsx(MenuList, { open: true }), _jsx("div", { className: "link-panel alt-font", children: _jsxs("div", { className: "link-panel-wrapper", children: [_jsxs("div", { className: "mobile-footer-logo", children: [_jsx(LogoGraphics, {}), _jsx(LogoTextGraphics, {})] }), _jsxs("div", { className: "link-panel-menu-container", children: [_jsxs("div", { className: "link-panel-menu", children: [_jsx("div", { className: "link-panel-menu-title", children: "Follow Us" }), !!setup?.footer_1 && getMenu(setup.footer_1)] }), _jsxs("div", { className: "link-panel-menu", children: [_jsx("div", { className: "link-panel-menu-title", children: "Legals" }), !!setup?.footer_2 && getMenu(setup.footer_2)] })] }), _jsx("div", { className: "link-panel-legal", children: setup?.legal ?? '' })] }) })] }) }) }) }), _jsx("div", { className: "footer-bottom-spacer" })] }));
};
export default Footer;
